import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobViewModel from '../../JobViewModel'
import JobProgressionViewModel from '../JobProgressionViewModel'
import { JobProgressionFlow } from 'jobs/progression/JobProgression'
import { match } from 'utils/pattern-match-util'
import styles from './DraftApproved.sass'
import TaxExtensionProgressionActions from '../TaxExtensionProgressionActions'

interface DraftApprovedProgressionProps {
  vm: JobProgressionViewModel
  jobVM: JobViewModel
  canCompleteJob?: boolean
}

export default observer(function DraftApprovedProgressionActions({
  vm,
  jobVM,
  canCompleteJob,
}: DraftApprovedProgressionProps) {
  return match(vm.currentProgressionFlow, {
    [JobProgressionFlow.OUTSOURCING]: () => (
      <OutsourcingActions
        vm={vm}
        jobVM={jobVM}
        canCompleteJob={canCompleteJob}
      />
    ),
    [JobProgressionFlow.RETAIL]: () => <RetailActions vm={vm} jobVM={jobVM} />,
    [JobProgressionFlow.ESSENTIAL]: () => null,
    [JobProgressionFlow.NONE]: () => null,
    [JobProgressionFlow.PREPARATION]: () => null,
    [JobProgressionFlow.REVIEW]: () => <ReviewActions vm={vm} />,
    [JobProgressionFlow.PERSONAL_EXTENSION]: () => null,
    [JobProgressionFlow.BUSINESS_EXTENSION]: () => null,
    [JobProgressionFlow.OUTSOURCING_EXTENSION]: () => null,
  })
})

const RetailActions = ({ vm }: DraftApprovedProgressionProps) => {
  return (
    <>
      <CardContent compactBottomPadding={vm.isAnyExtensionFlowAvailable}>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.answerAuthorizationSigned()}
          dataTest="job-progression-set-authorization-received-button"
        >
          Authorization was received
        </Button>
      </CardContent>

      {vm.isAnyExtensionFlowAvailable && (
        <TaxExtensionProgressionActions vm={vm} isSecondary />
      )}
    </>
  )
}

const OutsourcingActions = ({
  vm,
  jobVM,
  canCompleteJob,
}: DraftApprovedProgressionProps) => {
  return (
    <>
      {!vm.isAnyExtensionFlowAvailable && (
        <CardContent>
          <Button
            type="primary"
            size="wide-slim"
            onClick={() => vm.closeJob()}
            dataTest="job-progression-complete-job-button"
            disabled={!canCompleteJob}
          >
            Complete Job
          </Button>
          {!canCompleteJob && (
            <div className={styles.pendingActions}>
              {jobVM.pendingActionsText}
            </div>
          )}
        </CardContent>
      )}

      {vm.isAnyExtensionFlowAvailable && (
        <TaxExtensionProgressionActions vm={vm} />
      )}
    </>
  )
}

interface ReviewActionsProps {
  vm: JobProgressionViewModel
}

const ReviewActions = ({ vm }: ReviewActionsProps) => {
  return (
    <>
      <CardContent>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.viewReturnFiledDocumentCreationModal()}
          dataTest="job-progression-set-upload-review-notes-button"
        >
          Review Completed
        </Button>
      </CardContent>
    </>
  )
}
